export const LENSES_TRANSITION_OPACITY_MIN = 0;
export const LENSES_TRANSITION_OPACITY_MAX = 1;
export const LENS_MATERIAL_TYPES = [
    'TransitionsGradient',
    'SunRX',
    'static',
];
